var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 650,
    viewBox: "0 0 1024 650",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3042_75592)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 650,
    fill: "#D8DBE6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter0_dif_3042_75592)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M909.5 691C834.442 691 761.07 668.743 698.661 627.043C636.253 585.343 587.611 526.073 558.888 456.728C530.164 387.384 522.649 311.079 537.292 237.463C551.935 163.848 588.079 96.2271 641.153 43.1531C694.227 -9.9209 761.848 -46.0647 835.463 -60.7078C909.079 -75.3509 985.384 -67.8356 1054.73 -39.1121C1124.07 -10.3887 1183.34 38.2528 1225.04 100.661C1266.74 163.07 1289 236.442 1289 311.5C1289 412.15 1249.02 508.677 1177.85 579.847C1106.68 651.017 1010.15 691 909.5 691Z",
    fill: "url(#paint0_linear_3042_75592)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter1_dif_3042_75592)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M232 418C141.614 418 53.2578 391.227 -21.8955 341.066C-97.0487 290.905 -155.624 219.609 -190.213 136.195C-224.802 52.7806 -233.852 -39.0064 -216.219 -127.559C-198.585 -216.111 -155.06 -297.451 -91.1476 -361.294C-27.2351 -425.137 54.1946 -468.614 142.844 -486.228C231.493 -503.842 323.381 -494.802 406.886 -460.251C490.392 -425.699 561.766 -367.189 611.982 -292.118C662.197 -217.047 689 -128.787 689 -38.4999C689 82.5714 640.852 198.684 555.148 284.294C469.444 369.905 353.204 418 232 418Z",
    fill: "url(#paint1_linear_3042_75592)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter2_dif_3042_75592)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M362.5 1265C261.137 1265 162.051 1234.94 77.7704 1178.63C-6.50976 1122.31 -72.1981 1042.27 -110.988 948.625C-149.778 854.978 -159.927 751.932 -140.152 652.516C-120.377 553.101 -71.5664 461.782 0.107954 390.108C71.7823 318.434 163.101 269.623 262.516 249.848C361.932 230.073 464.978 240.222 558.625 279.012C652.272 317.802 732.314 383.49 788.628 467.77C844.942 552.051 875 651.137 875 752.5C875 888.423 821.005 1018.78 724.892 1114.89C628.78 1211 498.423 1265 362.5 1265Z",
    fill: "url(#paint2_linear_3042_75592)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dif_3042_75592",
    x: 478,
    y: -120,
    width: 863,
    height: 863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.713726 0 0 0 0 0.788235 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3042_75592"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3042_75592",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.713726 0 0 0 0 0.788235 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3042_75592"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26,
    result: "effect3_foregroundBlur_3042_75592"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dif_3042_75592",
    x: -277,
    y: -547,
    width: 1018,
    height: 1017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.713726 0 0 0 0 0.788235 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3042_75592"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3042_75592",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.713726 0 0 0 0 0.788235 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3042_75592"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26,
    result: "effect3_foregroundBlur_3042_75592"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dif_3042_75592",
    x: -202,
    y: 188,
    width: 1129,
    height: 1129,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.713726 0 0 0 0 0.788235 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3042_75592"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3042_75592",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.713726 0 0 0 0 0.788235 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3042_75592"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26,
    result: "effect3_foregroundBlur_3042_75592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3042_75592",
    x1: 581.284,
    y1: 129.443,
    x2: 1237.72,
    y2: 493.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D8ECA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3042_75592",
    x1: -163.243,
    y1: -257.497,
    x2: 626.836,
    y2: 181.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D8ECA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3042_75592",
    x1: -80.7432,
    y1: 506.639,
    x2: 805.743,
    y2: 998.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D8ECA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72D2FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3042_75592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 650,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground1);
export default __webpack_public_path__ + "static/media/background-1.7e9cd839dc34e66f16783baebd5e40ce.svg";
export { ForwardRef as ReactComponent };